import React from 'react';

const Products = props => {
    const { img, name, brand, generation, speed, price } = props.products;
    const {addItemBtn} = props;
    return (
        <div className="col-md-6 my-3">
                <div className="card border-secondary">
                <img src={img} className="img-thumbnail" alt="..." />
                <div className="card-body">
                    <h5 className="card-title">{name}</h5>
                    <p className="mb-1">Brnad: {brand}</p>
                    <p className="mb-1">Generation: {generation}</p>
                    <p>Speed: {speed}</p>
                    <h6>Price: {price}</h6>
                    <button onClick={ () => addItemBtn(props.products)} className="btn btn-info">Add Item</button>
                </div>
                </div>
        </div>
    );
};

export default Products;
